'use strict';
var KeywordBar, base, isBlank, placeholderState, unparam, whichKeyAlias;

unparam = require('../../general/m_unparam');

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

placeholderState = require('../helper/m_common').placeholderState;

isBlank = require('../../../../../core/frontend/common/underscore_mixins').isBlank;

module.exports = KeywordBar = (function() {
  function KeywordBar(arg) {
    var $form, env, initialKeyword;
    $form = arg.$form, env = arg.env;
    this.$form = $form;
    this.env = env || 'desktop';
    this.$input = this.$form.find('#ls-search');
    this.placeholder = this.$input.attr('placeholder');
    this.bind();
    if (!isBlank(initialKeyword = unparam().query)) {
      placeholderState.set(this.$input, 'hide');
      this.val(initialKeyword);
    }
    return;
  }

  KeywordBar.prototype.bind = function() {
    return this.$input.on('keydown', (function(_this) {
      return function(e) {
        if (whichKeyAlias(e) === 'Enter') {
          _this.$form.trigger('submit');
        }
      };
    })(this));
  };

  KeywordBar.prototype.setKeyword = KeywordBar.val;

  KeywordBar.prototype.val = function(value) {
    var currentVal;
    if (value != null) {
      return this.$input.val(value).removeClass('prompting');
    } else {
      currentVal = this.$input.val();
      if (isBlank(currentVal) || currentVal === this.placeholder) {
        return null;
      }
      return currentVal.trim();
    }
  };

  return KeywordBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

Object.assign(window.Groupon.Modules.SearchBar, {
  KeywordBar: KeywordBar
});

